export const DonationConfigWordings = {
  Formal: 'FORMAL',
  Informal: 'INFORMAL',
  InformalGeneric: 'INFORMAL_GENERIC',
} as const

export type DonationConfigWordings = (typeof DonationConfigWordings)[keyof typeof DonationConfigWordings]
export const DonationIntervals = {
  Monthly: 'MONTHLY',
  Single: 'SINGLE',
  Yearly: 'YEARLY',
} as const

export type DonationIntervals = (typeof DonationIntervals)[keyof typeof DonationIntervals]
export const MatchingEventCampaignTypes = {
  Spendenmarathon: 'SPENDENMARATHON',
  Verdopplungsaktion: 'VERDOPPLUNGSAKTION',
} as const

export type MatchingEventCampaignTypes = (typeof MatchingEventCampaignTypes)[keyof typeof MatchingEventCampaignTypes]
export const PaymentMethods = {
  DirectDeposit: 'DIRECT_DEPOSIT',
  DummyPayment: 'DUMMY_PAYMENT',
  Paypal: 'PAYPAL',
  StripeApplePay: 'STRIPE_APPLE_PAY',
  StripeCc: 'STRIPE_CC',
  StripeGooglePay: 'STRIPE_GOOGLE_PAY',
  StripeSepaDebit: 'STRIPE_SEPA_DEBIT',
} as const

export type PaymentMethods = (typeof PaymentMethods)[keyof typeof PaymentMethods]
/** Indicates where the component will be used */
export const PostdonationMessageUsecaseTypes = {
  /** Used within an iframe */
  Iframe: 'iframe',
  /** Used in the main platform */
  Platform: 'platform',
} as const

export type PostdonationMessageUsecaseTypes =
  (typeof PostdonationMessageUsecaseTypes)[keyof typeof PostdonationMessageUsecaseTypes]
export const ReceiverTypes = {
  FundraisingEvent: 'FUNDRAISING_EVENT',
  Project: 'PROJECT',
} as const

export type ReceiverTypes = (typeof ReceiverTypes)[keyof typeof ReceiverTypes]
export const UseCaseTypes = {
  /** Use case for donation alert audio uploads */
  DonationAlertAudio: 'donation_alert_audio',
  /** Use case for donation alert image uploads */
  DonationAlertImage: 'donation_alert_image',
  /** Use case for milestone audio uploads */
  MilestoneAudio: 'milestone_audio',
  /** Use case for milestone image uploads */
  MilestoneImage: 'milestone_image',
} as const

export type UseCaseTypes = (typeof UseCaseTypes)[keyof typeof UseCaseTypes]
export const VotingQuestionState = {
  Active: 'ACTIVE',
  Created: 'CREATED',
  Finished: 'FINISHED',
} as const

export type VotingQuestionState = (typeof VotingQuestionState)[keyof typeof VotingQuestionState]
